import React, { useState } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import styled from 'styled-components';
import Hit from '../assets/HIT2.jpg';

import NumericInput from 'react-numeric-input';
import {runHitV2} from '../actions';
import WaitModal from './waitModal';

import {isMobile } from 'react-device-detect';



function HitToolV2(props) {

  const [frameID, setFrameID] = useState('');
  const [stepSize, setStepSize] = useState(0.2);
  const [fillingRatio, setFillingRatio] = useState(0.95);
  const [mergeFile, setMergeFile] = useState('');
  const [modalIsOpen, setIsOpen] = useState(false);


  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const PostValues = ()=> {
     openModal();
     const {runHitV2} = props;

     runHitV2(frameID, stepSize, fillingRatio, mergeFile, ()=>closeModal());
  };

  return (
    <Container>
      <HeaderContainer>
        <Desc>This tool calculates the bound ions for biomolecules from MD simulation trajectories.</Desc>

      </HeaderContainer>

      <SubContainer isMobile={isMobile}>
        <Img src={Hit}/>
        <InputContainer>
        <Form>

          <Label>
            Frame ID:
            <input onChange={event => setFrameID(event.target.value)} type="text" name="frameID" />
          </Label>
          <Label>
            step size:
            <NumericInput
                onChange={valueAsNumber => setStepSize(valueAsNumber)}
                step={0.1}
                precision={2}
                value={stepSize}
                />
          </Label>
          <Label>
            filling ratio:
            <NumericInput
                onChange={valueAsNumber => setFillingRatio(valueAsNumber)}
                step={0.1}
                precision={2}
                value={fillingRatio}
                />
          </Label>
          <Label>
            Upload .pdb file (250 MB):
            <input onChange={event => setMergeFile(event.target.files[0])} type="file" name="mergeFile" accept=".pdb" />
          </Label>
        </Form>
          <Button color="#7eb35b" marginTop="20px" onClick={()=>PostValues()}> Submit </Button>
         </InputContainer>


      </SubContainer>

      <WaitModal modalIsOpen={modalIsOpen} closeModal={()=>closeModal()} />

    </Container>

  );
}

const Container = styled.div`
  family-font:'Fira Sans';
`;

const SubContainer = styled.div`
  display: flex;
  flex-direction: ${props=> props.isMobile ? "column" : "row"};
  justify-content: space-around;
  align-items:center;
`;

const InputContainer = styled.div`
`;

const Img = styled.img`
	height: 31vw;
  max-width:652px;
`;



const Form = styled.form`
  display:flex;
  flex-direction:column;
`;

const Label = styled.label`
  display:flex;
  flex-direction:column;
  font-size:15px;
`;

const Button = styled.button`
		border: none;
		width: 200px;
		height:50px;
		margin-right:10px;
		color: #fff;
		background-color: ${props => props.color};
		font-size: 1.2em;
		transform-style: preserve-3d;
		outline: none;
		cursor: pointer;
		border-radius: 0.27em;
		text-align: center;
		font-family:'Fira Sans';
    box-shadow: 2px 4px 6px rgb(0 0 0 / 30%);
    margin-bottom:${props => props.marginBottom};
    margin-top:${props => props.marginTop};
`;





const Desc = styled.div`
    font-size:22px;
    margin-bottom:40px;
`;

const HeaderContainer = styled.div`
  display:flex;
  width: 100%;
  justify-content:space-between;
  align-items:center;
  font-size:18px;
`;


const mapDispatchToProps = dispatch => {

  return bindActionCreators({runHitV2}, dispatch);

};


export default connect(null,mapDispatchToProps)(HitToolV2);



// WEBPACK FOOTER //
// ./src/components/hitToolV2.js